import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import { authModule } from './auth/auth-module';
import { orderModule } from './orders/orders-module';
import { productModule } from './product/product-module';
import { cartModule } from './cart/cart-module';
import { checkoutModule } from './checkout/checkout-module';
import { categoriesModule, } from './categories/categories-module';
import { userModule } from './user/user-module';
import { brandsModule } from './brands/brands-module';
import { searchModule } from './search/search-module';
import { wishlistModule } from './wishlist/wishlist-module';
import { settingsModule, } from '@/store/settings/settings-module';
import { alcoholModule } from './alcohol/alcohol-module';
Vue.use(Vuex);
const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
});
export default new Vuex.Store({
    mutations: {},
    actions: {},
    modules: {
        productModule,
        authModule,
        orderModule,
        userModule,
        cartModule,
        categoriesModule,
        checkoutModule,
        brandsModule,
        searchModule,
        wishlistModule,
        settingsModule,
        alcoholModule,
    },
    plugins: [vuexLocal.plugin],
});
